import { render, staticRenderFns } from "./luma.vue?vue&type=template&id=b5e05b96&scoped=true"
import script from "./luma.vue?vue&type=script&lang=js"
export * from "./luma.vue?vue&type=script&lang=js"
import style0 from "./luma.vue?vue&type=style&index=0&id=b5e05b96&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e05b96",
  null
  
)

export default component.exports